<div class="new-companies">
  <div class="new-companies__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'companies.new_companies.hero_title' | translate }}</h1>
      <p class="vacancy-hero__subtitle">{{ 'companies.new_companies.hero_subtitle' | translate }}</p>
    </div>
  </div>

  <div class="vacancy-container new-companies__content">
    <div class="vacancy-grid">
      <bwc-company-card
        *ngFor="let company of companies"
        [company]="company"
        [isFollowed]="isFollowed(company.id)"
        [showNewBadge]="true"
        (followed)="toggleFollow($event)"
      ></bwc-company-card>
    </div>
  </div>
</div>
